module.exports = __webpack_public_path__ + "static/img/m_global_flow_step2@3x.cf707c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_global_flow_step2@3x.png
// module id = Nu/C
// module chunks = 1